"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
var _taxSubMenu = require("./subMenus/tax-sub-menu");
var _sourceSubMenu = require("./subMenus/source-sub-menu");
var _industriesSubMenu = require("./subMenus/industries-sub-menu");
var _company = require("./subMenus/company");
var _state = require("./subMenus/state");
var _licenseTcSubMenu = require("./subMenus/licenseTc-sub-menu");
const masterRouter = {
  path: '/masters',
  component: _index.default,
  redirect: 'noredirect',
  name: 'Masters',
  meta: {
    roles: ['Super Admin', 'Admin', 'Product Manager', 'System Admin'],
    title: 'master.title',
    icon: 'star'
  },
  children: [..._sourceSubMenu.sourceSubMenu, ..._company.companySubMenu, ..._state.stateSubMenu,
  // ...conceptSubMenu,
  // ...occasionSubMenu,
  ..._industriesSubMenu.industriesSubMenu, ..._taxSubMenu.taxSubMenu, ..._licenseTcSubMenu.licenseTcSubMenu, ...[{
    path: '/setting/info',
    component: () => {
      console.log('Settings page loaded');
      return Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/setting/info.vue')));
    },
    name: 'settings',
    meta: {
      roles: ['Super Admin', 'Product Manager', 'System Admin'],
      title: 'settingManagement.settings.title',
      noCache: true,
      icon: 'lock'
    }
  }]]
};
var _default = exports.default = masterRouter;